<template>
  <div>
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <div v-else>

      <section>

        <div class="head">二维码真伪识别与应用系统</div>

        <div class="swiper-container banner">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-if="datas.focus && datas.focus_pics_is_show == 1" v-for="(item,index) in datas.focus" v-bind:key="index"><img :src="item.img"></div>
          </div>
        </div>

        <div class="box">
        	<div class="title"><i>!</i>你查询的防伪码：</div>
        	<div class="querybox"><input :value="vcode" /></div>
          <div class="hint hint-warn" v-if="datas.scan_count > 1">你所查询的防伪码已被查询过，首次查询时间：<i v-text="datas.scan_first_time"></i>,查询方式：网络,请确认!此次是第<i v-text="datas.scan_count"></i>次查询!</div>
        	<div class="hint hint-correct" v-else>你所查询的防伪码为正确，请放心使用!</div>
        	<div class="main-box" v-if="datas.business && datas.business_is_show == 1">
        		<p v-text="datas.business.name"></p>
        		<p v-text="'公司地址：'+datas.business.baddress"></p>
        		<p v-text="'客服热线：'+datas.business.linkphone"></p>
        		<p v-text="'销售热线：'+datas.business.linkphone"></p>
        	</div>

        	<div class="btn-box" v-if="datas.menu && datas.menu_is_show == 1">
        		<a v-for="(item,index) in datas.menu" v-bind:key="index" @click="ClickMenu(item)">{{item.name}}<i class="triangle"></i></a>
        	</div>

        	<div class="all-rights">© 温州链接科技有限公司 保留一切权利 浙ICP备2021035319号</div>
        </div>

      </section>

    </div>
  </div>
</template>

<script>
let self,map;
import axios from 'axios'
import Swiper from 'swiper'
import Loading from '@/components/Loading.vue'
import Music from '@/components/Music.vue'
export default {
  name: 'AntiFake02',
  components: {
    'K-Loading': Loading,
    'K-Music': Music
  },
  data () {
    return {
      code:null,
      vcode:null,
      count:2,
      datas:null,
      Loading:{
        type:1,
        txt:"数据请求中..."
      },
      Music:{
        url:null,
        type:false
      },
      location:null,
      ModulList:[{
        id:"business-box",
        name:"商户"
      },{
        id:"trace-box",
        name:"溯源"
      },{
        id:"video-box",
        name:"视频"
      },{
        id:"ref-box",
        name:"推荐"
      },{
        id:"menu-box",
        name:"菜单"
      }]
    }
  },
  created () {
    self = this;

    //判断是演示还是真实码标
    if(this.$route.query.type == "demo"){
      self.randomCode();
      self.GetDemoDatas(this.$route.query.pid,this.$route.query.rid);  //获取演示模板信息
    }else{
      self.code = self.GetCode();
      self.GetDatas();  //获取码标信息
    }
  },
  updated () {
    new Swiper('.banner',{
      autoplay: true,//可选选项，自动滑动
      loop: true, //可选选项，开启循环
    })
  },
  methods:{
    GetDemoDatas (pid,rid) {
      axios.get(self.GetServerUrl(1)+"template_product/"+pid+"/"+rid)
      .then(function (response){
        let datas = response.data.meta;
        let defaultDatas = JSON.parse(datas.default_basic.config_value);  //初始化默认信息
        console.log(datas)
        if(datas.scan_count){
          datas.scan_count = datas.scan_count;
        }else{
          datas.scan_count = 1;
        }
        datas.scan_first_time = "2017-10-31 12:12";
        datas.scan_first_address = "广东省深圳市";
        if(datas.focus){
          datas.focus = JSON.parse(datas.focus);
        }
        if(datas.ref){
          datas.ref = JSON.parse(datas.ref);
        }else{
          if(defaultDatas.ref){
            datas.ref = JSON.parse(defaultDatas.ref);
          }
        }
        if(datas.menu){
          datas.menu = JSON.parse(datas.menu);
        }
        if(datas.batch){
          datas.batch = JSON.parse(datas.batch);
          datas.batch.qc = JSON.parse(datas.batch.qc);
        }
        if(datas.music && datas.music_is_show == 1){
          try {
            datas.music = JSON.parse(datas.music);
          } catch (error) {
            console.error(error)
          }
        }
        if(datas.video){
          datas.video = JSON.parse(datas.video);
        }
        datas.activity_is_show = 1;

        //产品自定义属性
        if(datas.product.attribute){
          datas.product.attribute = JSON.parse(datas.product.attribute);
        }

        //企业自定义属性
        if(datas.business.customize_data){
          datas.business.customize_data = JSON.parse(datas.business.customize_data);
        }

        //默认信息
        if(!datas.process){
          datas.process = defaultDatas.process;
        }
        if(!datas.process_demo){
          datas.process_demo = defaultDatas.process_demo;
        }
        if(!datas.dealer){
          datas.dealer = defaultDatas.dealer;
        }
        self.datas = datas;

        // document.title = self.datas.business.name;  //设置页面标题
      }).catch(function (error){
        console.log(error)
        self.Loading.type = 3;
        self.Loading.txt = self.ErrorHint(error);
      })
    },
    GetDatas () {
      axios.get(self.GetServerUrl(1)+"query/"+self.code)
      .then(function (response){

        let datas = response.data.meta.product_template;
        datas.scan_count = response.data.meta.scan_count;  //扫码次数
        datas.scan_first_time = response.data.meta.scan_first_time;  //扫码时间
        datas.scan_first_address = response.data.meta.scan_first_address;  //扫码地点
        if(response.data.meta.verify){
          self.vcode = response.data.meta.verify;
        }else{
          self.randomCode();
        }

        //产品自定义属性
        if(datas.product.attribute){
          datas.product.attribute = JSON.parse(datas.product.attribute);
        }

        //企业自定义属性
        if(datas.business.customize_data){
          datas.business.customize_data = JSON.parse(datas.business.customize_data);

          if(datas.business.customize_data){
            for(let i in datas.business.customize_data){
              if(datas.business.customize_data[i].key == "经纬度"){
                self.location = datas.business.customize_data[i].value;
              }
            }
          }

        }
        //焦点图
        if(datas.focus){
          datas.focus = JSON.parse(datas.focus);
        }
        //自定义栏目
        if(datas.ref){
          datas.ref = JSON.parse(datas.ref);
        }
        //自定义菜单
        if(datas.menu){
          datas.menu = JSON.parse(datas.menu);
        }
        //批次信息
        if(datas.batch){
          if(datas.batch.qc){
            datas.batch.qc = JSON.parse(datas.batch.qc);
          }
        }
        if(datas.music && datas.music_is_show == 1){
          try {
            datas.music = JSON.parse(datas.music);
          } catch (error) {
            console.error(error)
          }
        }
        if(datas.video){
          datas.video = JSON.parse(datas.video);
        }
        datas.activity_is_show = 1;
        self.datas = datas;

        // document.title = self.datas.business.name;  //设置页面标题
      }).catch(function (error){
        console.log(error)
        self.Loading.type = 3;
        self.Loading.txt = self.ErrorHint(error);
      })
    },
    inited (viewer) {
      self.$viewer = viewer
    },
    PreviewImgs () {
      self.$viewer.show();
      self.$viewer.update();
    },
    ClickMenu (data) {
      if(data.type != 2){
        window.location.href = data.url;
      }else{
        this.$router.push({path: "/qr?qr="+data.qr});
      }
    },
    randomCode (){ //生成随机码
      while(self.vcode<100000){
      	self.vcode = Math.floor(Math.random()*1000000);
      }
    }
  }
}
</script>

<style scoped>
  .box{
  	padding:15px 20px;
  	background-color: #f6f6f6;
  }
  .banner img{
    width: 100%;
    display: block;
  }
  .head{
  	color:#FFF;
  	text-align: center;
  	padding:3px;
  	background-color: #2d2d2d;
  }
  .title{
  	color: #888;
  	font-size: 14px;
  	position: relative;
  	padding-left: 25px;
  }
  .title i{
  	color:#FFF;
  	font-weight: bold;
  	font-style: normal;
  	width: 20px;
  	height: 20px;
  	text-align: center;
  	display: table;
  	border-radius: 10px;
  	background-color: #678d2a;
  	position: absolute;
  	left:0;top:0;
  }
  .querybox{
  	margin-top:10px;
  }
  .querybox input{
  	border:1px solid #dedede;
  	width: calc(100% - 10px);
  	padding:10px 5px;
  	font-size: 15px;
  	border-radius: 5px;
  }
  .hint{
  	padding:8px 0;
  }
  .hint-warn{
  	color:#e92d2e;
  }
  .hint-correct{
  	color:#729c2e;
  }
  .main-box{
  	padding:8px 0;
  	border-top: 1px dashed #666;
  	border-bottom: 1px dashed #666;
  }
  .main-box p{
  	padding-top:5px;
  	font-size:13px;
  	color:#555;
  }
  .main-box p:first-child{
  	padding-top:0;
  }
  .btn-box{
  	width: 60%;
  	margin:0 auto;
  	margin-top: 10px;
  	overflow: hidden;
  }
  .btn-box a{
  	float: left;
  	width: calc(50% - 15px);
  	color: #FFF;
  	padding:8px 0;
  	font-size:14px;
    margin-bottom: 10px;
  	padding-right: 10px;
  	border-radius: 5px;
  	text-align: center;
  	text-decoration: none;
  	background-color: #729c2e;
  	position: relative;
  }
  .btn-box a:first-child{
  	margin-right: 10px;
  }
  .triangle{
  	position:absolute;
  	width: 0px;
  	height: 0px;
  	right:0;top:calc(50% - 7px);
  	border: 7px solid;
  	border-left-color: #FFF;
  	border-right-color: transparent;
  	border-top-color:  transparent;
  	border-bottom-color: transparent;
  }
  .all-rights{
  	margin-top: 10px;
  	text-align: center;
  	font-size: 13px;
  	color:#888888;
  }
</style>



// WEBPACK FOOTER //
// src/view/AntiFake02.vue